import axios from "axios"

export const rootUrl = axios.create ({baseURL:"https://erp.apitco.org:8093",})

//export const rootUrl = axios.create ({baseURL:"http://localhost:8093",})


export const APP_BASE_URL = "http://localhost:3000";
